<template lang="html">
  <div class="area-wrapper">
    <chooseAddress
      v-model="area"
      :districtId="areaCode || '320102'"
      :chooseIsShow="true"
    ></chooseAddress>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import chooseAddress from '../address/atom/choose'

export default {
  data() {
    return {
      area: ''
    }
  },
  watch: {
    async area(val, oldVal) {
      if (oldVal !== '') {
        if (val.over) {
          this.setSelectedAddress(val)
          this.hideActionSheet(false)
          let areaCode = ''
          if (
            this.selectedAddress.regionid &&
            this.selectedAddress.regionid !== ''
          ) {
            areaCode = this.selectedAddress.regionid.split('_')[2]
          }
          // 获取服务人员
          console.log(333)
          await this.$store.dispatch('getWorkers', {
            spuId: this.$route.params.spuId,
            serviceDate: this.selectedTime,
            districtId: areaCode
          })
          this.$$tracker(
            '100101',
            '20000',
            21019,
            this.selectedAddress.province,
            this.selectedAddress.city,
            this.selectedAddress.district
          )
        }
      }
    }
  },
  computed: {
    ...mapState(['locationInfo', 'selectedAddress']),
    areaCode() {
      let areaCode = ''
      if (
        this.selectedAddress.regionid &&
        this.selectedAddress.regionid !== ''
      ) {
        areaCode = this.selectedAddress.regionid.split('_')[2]
      }
      return areaCode
    }
  },
  methods: {
    ...mapMutations(['setSelectedAddress', 'hideActionSheet'])
  },
  components: {
    chooseAddress
  }
}
</script>

<style lang="scss" scoped>
.area-wrapper {
  height: 100%;
}
</style>
